import { QueryClient } from '@tanstack/react-query'

/**
 * Defaults tuned for a booking app on mobile networks: cached reads stay usable
 * for a short window, writes are never retried blindly.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        retry: 2,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: 0,
      },
    },
  })
}
